import { Dispatch, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../store/ApplicationState";
import { ModuleActionDispatchTypes } from "../constants/Modules";
import { ModulesDispatchTypes } from "../models/DispatchTypes/Modules";
import { GetModules } from "../services/Module";
import { baseUrl } from "../constants/Config";

export const getUserModule: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ModulesDispatchTypes
  >
> = () => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: ModuleActionDispatchTypes.MODULE_INVOKE,
    });
    const response =  await GetModules(baseUrl);
    dispatch({
      response,
      type: ModuleActionDispatchTypes.MODULE_SUCCESS,
    });
  };
};
